import { SERVICE_PAGE_QUERY, ServicePage as Service } from "#app/queries/service.ts";
import { CmsSection } from "#app/components/cms-section.tsx";
import { Route } from "./+types/$slug";
import { BASE_URL, COMPANY_NAME } from "#app/utils/constants.ts";
import { getSeoMeta } from "#app/utils/seo/getSeoMeta.ts";
import { breadcrumbSchema, faqPageSchema, faqsFromSections, serviceSchema } from "#app/utils/seo/structured-data.ts";
import { SERVICE_COUNTY_NAMES } from "#app/utils/constants.ts";


export const meta: Route.MetaFunction = ({ data }) => {
    const servicePage = data?.service;
    const title = servicePage?.seo?.metaTitle || COMPANY_NAME;
    const description = servicePage?.seo?.metaDescription || `${COMPANY_NAME} residential services`;
    const path = '/services/' + servicePage?.slug?.current;
    const url = BASE_URL + path;
    // FAQPage only where the questions are actually rendered on the page.
    const faqs = faqsFromSections(servicePage?.sections);
    return getSeoMeta({
        title,
        description,
        url,
        jsonLd: [
            serviceSchema({
                name: servicePage?.title || title,
                description: servicePage?.seo?.metaDescription,
                url,
                areaServed: SERVICE_COUNTY_NAMES,
            }),
            breadcrumbSchema([
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: servicePage?.title || 'Service', path },
            ]),
            ...(faqs.length ? [faqPageSchema(faqs)!] : []),
        ] as any,
    })
}

export const loader = async ({ request, params }: Route.LoaderArgs) => {
    const { client } = await import('#app/utils/sanity-client.ts')
    const query = SERVICE_PAGE_QUERY.query
    const service = await client.fetch<Service>(query, params)

    if (!service) {
        throw new Response('Not found', { status: 404 })
    }
    return {
        service
    }
}


export default function ServicePage({loaderData}: Route.ComponentProps) {
    const {service} = loaderData
    return (
        <main>
            {service?.sections.map((section) => (<CmsSection key={section._key} data={section} />))}
        </main>
    )
}